import i18n from "@/libs/i18n/i18n";

export default () => ({
  title: "",
  countries:[],
  issuedCountries:[],
  country:"",
  countryToEdit: '',
  status: '',
  total: "",
  code: null,
  dialCode: null,


  isArabCountries:  [
    { value: "true", text: i18n.t("general.yes") },
    { value: "false", text: i18n.t("general.no") },
  ],
  isArabCountry : 'false'

});
